const share = {
  namespaced: true,
  state: () => ({
    token: 0,
    subAppTabs: []
  }),
  getters: {
    token: (state) => state.token,
    subAppTabs: (state) => state.subAppTabs
  },
  mutations: {
    setToken: (state, payload) => {
      Object.assign(state, { token: payload })
    },
    updateShareInfo: (state, payload) => {
      Object.assign(state, payload)
      // 将 payload 中的所有变量赋值到 state 中，并从 state 中移除 payload 中不存在的 key
      Object.keys(state).forEach(key => {
        if (!(key in payload)) {
          delete state[key]
        }
      })
    }
  },
  actions: {
    setToken: ({ commit }, payload) => {
      commit('setToken', payload)
    },
    updateShareInfo: ({ commit }, payload) => {
      commit('updateShareInfo', payload)
    }
  }
}
export default share
